import { useFlag } from '@unleash/proxy-client-react';
import useCurrentAccount from '../useCurrentAccount';
import { isProduction } from '~/util';

/**
 * List all flags created inside of Gitlab
 * When adding new once please update this type and also list them in `docs/components/FeatureFlags/index.tsx`
 * @see https://gitlab.bndl.nl/dh/sfa-app/-/feature_flags
 */
export type Flag =
  | 'is-developer'
  | 'holiday-cheer'
  | 'pride-month'
  | 'custom-html'
  | 'form-builder'
  | 'biedwijzer';

const useDHFlag = (flag: Flag): boolean => {
  const enabled = useFlag(flag);
  const currentAccount = useCurrentAccount();

  if (flag === 'biedwijzer') {
    if (!isProduction()) return true;

    // Dev accounts and bndl circle members
    switch (currentAccount.id) {
      case 'a---94ad533b-3b1b-48dc-9b51-c9ab0bed8248':
      case 'a---a80b0a9e-c0a4-4d33-a1f5-c6289cc9db15':
      case 'a---400178c5-fc92-4715-9cfa-14732a403875':
      case 'a---582842d1-0376-4330-9ad1-82ac8ec6f8bb':
      case 'a---43a22a0e-830d-4a6b-b250-b0db4c8d8420':
      case 'a---96ce6d1c-6bf3-409c-9525-a8a85f38033f':
      case 'a---53d76bbb-0703-48ff-8dbe-0d944dfec752':
      case 'a---e48cad50-7fa1-4eb0-af06-c11d0d80e05a':
      case 'a---b1deeae4-690a-4aad-81ff-d74125d2ee2c':
      case 'a---f4ac6851-fa80-4262-9ace-131ae070be2c':
      case 'a---99601074-de20-483d-9c04-5e2c8dd7b17d':
      case 'a---ffa9383f-8ae1-49fa-baf4-e81c40948059':
      case 'a---f0007d2c-ecd7-47c7-b1b7-05fc4912ab83':
      case 'a---e8cb3335-6e94-45f6-b873-2781c316d21f':
      case 'a---4fe5431b-7cb8-45a8-b55a-431530ac5b72':
      case 'a---30a5a1bc-e854-4485-9e58-d3b303778bc8':
      case 'a---c2a26802-4512-4c51-99e8-a91403912e6c':
      case 'a---d9e48779-7786-4f0c-a619-d02ec81bfcf3':
      case 'a---d3aabdfa-1d01-4683-affd-f70170910d26':
      case 'a---dca9c71f-494b-4ec5-9b2d-507cb3b49909':
        return true;
    }
    return false;
  }

  return enabled;
};

export default useDHFlag;
